import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import { retry } from 'hub-http/middlewares/core';
import hubapiStack from 'hub-http/stacks/hubapi';

/**
 * Creates an api client with custom retries logic.
 * Doesn't retry on network error
 */
export const createRetryClient = ({
  maxRetries = 1,
  retryOn400s = false,
  delay = 500
}) => {
  const retryOptions = {
    maxRetries,
    delay
  };
  const minErrorStatus = retryOn400s ? 400 : 500;
  const retryMiddleware = retry(response => response.status >= minErrorStatus, retryOptions);
  return promiseClient(createStack(retryMiddleware, hubapiStack));
};